<script lang="ts">
    import Popup from "@components/popup/Popup.svelte"
    import PopupBanner from "@components/popup/PopupBanner.svelte"
    import PopupButtons from "@components/popup/PopupButtons.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import Button from "@components/button/Button.svelte"
    import {
        findHighlight,
        updateHighlight,
        type HighlightID,
        refreshHighlighterStore,
    } from "@store/highlights"
    import { createEventDispatcher } from "svelte"
    import Portal from "svelte-portal"
    import "@utils/web-components/plain-text-only"

    export let highlightID: HighlightID
    $: highlight = findHighlight(highlightID)

    $: text = highlight?.note ?? ""
    function save() {
        if (highlight === null)
            throw new Error("The highlight that was trying to be saved does not exist")
        highlight.note = text
        updateHighlight(highlight).then(() => refreshHighlighterStore())
        exit()
    }
    const dispatch = createEventDispatcher()
    function exit() {
        dispatch("exit")
    }

    function enterKey(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (e.shiftKey === false) {
                e.preventDefault()
                save()
            }
        }
    }

    let textElement: HTMLDivElement
</script>

<Portal>
    <Popup>
        <PopupExit on:exit={exit} />
        {#if highlight}
            <PopupBanner>
                <PopupHeading>Edit Note</PopupHeading>
            </PopupBanner>
            <div
                bind:this={textElement}
                contenteditable="true"
                class="content-editable multiline"
                on:keydown={enterKey}
                on:input={(e) => (text = textElement.textContent || "")}
            >
                {highlight.note}
            </div>
            <plain-text-only />
            <PopupButtons>
                {#if highlight.hasNote}
                    <Button
                        color="gold"
                        go={() => {
                            text = ""
                            save()
                        }}
                    >
                        Remove
                    </Button>
                {/if}
                <Button color="white" go={exit}>Cancel</Button>
                <Button go={save}>Save</Button>
            </PopupButtons>
        {:else}
            Popup not found!
        {/if}
    </Popup>
</Portal>
